import { Navigate, useSearchParams } from 'react-router-dom'

/** Legacy route — painted/raw package step removed; send handoffs to Bliss Basic home. */
export default function BlissBasicPackageOfferings() {
  const [searchParams] = useSearchParams()
  const search = searchParams.toString()
  return <Navigate to={search ? `/?${search}` : '/'} replace />
}
